import * as actionTypes from "./actionTypes";


export const loadStateDistrictList = (data) => {
  return {
    type: actionTypes.LOAD_STATE_DISTRICT_LIST
  };
};

export const loadStateDistrictListSuccess = data => {
  return {
    type: actionTypes.LOAD_STATE_DISTRICT_LIST_SUCCESS,

    data
  };
};


export const loadLanguages = (data) => {
  return {
    type: actionTypes.LOAD_LANGUAGUES,
    data
  };
};

export const loadLanguagesSuccess = data => {

  return {
    type: actionTypes.LOAD_LANGUAGUES_SUCCESS,
    data
  };
};


export const loadLanguagesFail = () => {
  return {
    type: actionTypes.LOAD_LANGUAGUES_FAIL
  };
};



export const loadExpressRecyclingList = (data) => {
  return {
    type: actionTypes.LOAD_EXPRESS_RECYCLING_LIST,
    data
  };
};

export const loadExpressRecyclingListSuccess = data => {

  return {
    type: actionTypes.LOAD_EXPRESS_RECYCLING_LIST_SUCCESS,
    data
  };
};


export const loadExpressRecyclingListFail = () => {
  return {
    type: actionTypes.LOAD_EXPRESS_RECYCLING_LIST_FAIL
  };
};


export const loadRecyclingList = (data) => {
  return {
    type: actionTypes.LOAD_RECYCLING_LIST,
    data
  };
};

export const loadRecyclingListSuccess = data => {

  return {
    type: actionTypes.LOAD_RECYCLING_LIST_SUCCESS,
    data
  };
};


export const loadRecyclingListFail = () => {
  return {
    type: actionTypes.LOAD_RECYCLING_LIST_FAIL
  };
};





export const loadRecyclingCategory = data => {
  
  return {
    type: actionTypes.LOAD_RECYCLING_CATEGORY,
    data
  };
};

export const loadRecyclingCategorySuccess = data => {
  return {
    type: actionTypes.LOAD_RECYCLING_CATEGORY_SUCCESS,
    data
  };
};

export const loadRecyclingCategoryFail = () => {
  return {
    type: actionTypes.LOAD_RECYCLING_CATEGORY_FAIL
  };
};


export const loadRecyclingExtraFee = data => {
  
  return {
    type: actionTypes.LOAD_RECYCLING_EXTRA_FEE,
    data
  };
};

export const loadRecyclingExtraFeeSuccess = data => {
  return {
    type: actionTypes.LOAD_RECYCLING_EXTRA_FEE_SUCCESS,
    data
  };
};

export const loadRecyclingExtraFeeFail = () => {
  return {
    type: actionTypes.LOAD_RECYCLING_EXTRA_FEE_FAIL
  };
};



export const loadRecyclingDumpster = data => {
  
  return {
    type: actionTypes.LOAD_RECYCLING_DMPSTER,
    data
  };
};

export const loadRecyclingDumpsterSuccess = data => {
  return {
    type: actionTypes.LOAD_RECYCLING_DMPSTER_SUCCESS,
    data
  };
};

export const loadRecyclingDumpsterFail = () => {
  return {
    type: actionTypes.LOAD_RECYCLING_DMPSTER_FAIL
  };
};


export const loadDumpsterService = data => {
  
  return {
    type: actionTypes.LOAD_DMPSTER_SERVICE,
    data
  };
};

export const loadDumpsterServiceSuccess = data => {
  return {
    type: actionTypes.LOAD_DMPSTER_SERVICE_SUCCESS,
    data
  };
};

export const loadDumpsterServiceFail = () => {
  return {
    type: actionTypes.LOAD_DMPSTER_SERVICE_FAIL
  };
};



//Carbon Footprint
export const loadImpactCarbon = data => {
  
  return {
    type: actionTypes.LOAD_IMPACT_CARBON,
    data
  };
};

export const loadImpactCarbonSuccess = data => {
  return {
    type: actionTypes.LOAD_IMPACT_CARBON_SUCCESS,
    data
  };
};

export const loadImpactCarbonFail = () => {
  return {
    type: actionTypes.LOAD_IMPACT_CARBON_FAIL
  };
};


export const getImpactCarbonCert = data => {
  
  return {
    type: actionTypes.GET_IMPACT_CARBON_CERT,
    data
  };
};

export const getImpactCarbonCertSuccess = data => {
  return {
    type: actionTypes.GET_IMPACT_CARBON_CERT_SUCCESS,
    data
  };
};

export const getImpactCarbonCertFail = () => {
  return {
    type: actionTypes.GET_IMPACT_CARBON_CERT_FAIL
  };
};




export const getGeneralSetting = data => {
  
  return {
    type: actionTypes.GET_GENERAL_SETTING,
    data
  };
};

export const getGeneralSettingSuccess = data => {
  return {
    type: actionTypes.GET_GENERAL_SETTING_SUCCESS,
    data
  };
};

export const getGeneralSettingFail = () => {
  return {
    type: actionTypes.GET_GENERAL_SETTING_FAIL
  };
};


export const loadCharities = data => {
  
  return {
    type: actionTypes.LOAD_CHARITIES,
    data
  };
};

export const loadCharitiesSuccess = data => {
  return {
    type: actionTypes.LOAD_CHARITIES_SUCCESS,
    data
  };
};

export const loadCharitiesFail = () => {
  return {
    type: actionTypes.LOAD_CHARITIES_FAIL
  };
};


export const loadVendingCategory = data => {
  
  return {
    type: actionTypes.LOAD_VENDING_CATEGORY,
    data
  };
};

export const loadVendingCategorySuccess = data => {
  return {
    type: actionTypes.LOAD_VENDING_CATEGORY_SUCCESS,
    data
  };
};

export const loadVendingCategoryFail = () => {
  return {
    type: actionTypes.LOAD_VENDING_CATEGORY_FAIL
  };
};


export const driverList = data => {
  
  return {
    type: actionTypes.LOAD_DRIVER_LIST,
    data
  };
};

export const driverListSuccess = data => {
  return {
    type: actionTypes.LOAD_DRIVER_LIST_SUCCESS,
    data
  };
};

export const driverListFail = () => {
  return {
    type: actionTypes.LOAD_DRIVER_LIST_FAIL
  };
};

export const driverDRVMDumpsterList = (id, data) => {
  
  return {
    type: actionTypes.LOAD_DRIVER_DUMPSTER,
    id,
    data
  };
};

export const driverDRVMDumpsterListSuccess = data => {
  return {
    type: actionTypes.LOAD_DRIVER_DUMPSTER_SUCCESS,
    data
  };
};

export const driverDRVMDumpsterListFail = () => {
  return {
    type: actionTypes.LOAD_DRIVER_DUMPSTER_FAIL
  };
};

export const landfillPointList = data => {
  
  return {
    type: actionTypes.LOAD_LANDFILL_POINT,
    data
  };
};

export const landfillPointListSuccess = data => {
  return {
    type: actionTypes.LOAD_LANDFILL_POINT_SUCCESS,
    data
  };
};

export const landfillPointListFail = () => {
  return {
    type: actionTypes.LOAD_LANDFILL_POINT_FAIL
  };
};